import type { Contact } from "../types";

export const getContactDetails = (contact?: Contact | null) => {
  return (contact as any)?.details || {};
};

export const getContactDisplayName = (contact?: Contact | null) => {
  if (!contact) return "";
  const details = getContactDetails(contact);
  const fullName = details.name || "";
  return fullName.trim();
};

export const getContactDetail = <T = string>(
  contact: Contact | null | undefined,
  key: string,
  fallback?: T
): T | undefined => {
  if (!contact) return fallback;
  const details = getContactDetails(contact);
  if (details[key] != null) return details[key] as T;
  return fallback;
};
